import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import editIcon from "../../../assets/images/budget/dropdown.png";
import addIcon from "../../../assets/images/DeathModuleNew/addIcon.png";
import oneTimeFundingImg from "../../../assets/images/latest/Contributions.png";
import recurringImg from "../../../assets/images/latest/Future-money.png";
import { Icon } from "antd";
import { StrategyReport } from "../components/StrategyReport";
import { StrategyAmortization } from "../components/StrategyAmortization";
import { MODULE_API } from "../../../apis";
import FETCH from "../../../utils/fetch";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import {
  calculateDebtPayoff,
  generateAmortizationData,
} from "../../../helpers/amortizationCalcultion";
import moment from "moment";
import swal from "sweetalert";
import { AddOneTimeFunding } from "../components/AddOneTimeFunding";
import { AddMonthlyExtra } from "../components/AddMonthlyExtra";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
export const DebtStrategy = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [amortizationLoading, setAmortizationLoading] = useState(false);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [amortizationData, setAmortizationData] = useState(null);
  const [oneTimeFundingData, setOneTimeFundingData] = useState([]);
  const [oneTimeFundingDataUnpaid, setOneTimeFundingDataUnpaid] = useState([]);
  const [oneTimeFunding, setOneTimeFunding] = useState([]);
  const [extraAmount, setExtraAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [formDataExtra, setFormDataExtra] = useState(null);
  const [amortizationDataWithNoSnowball, setAmortizationDataWithNoSnowball] =
    useState(null);

  const [showModalRecuring, setShowModalRecuring] = useState(false);
  const handleChangeExtra = (name, value) => {
    setFormDataExtra({
      ...formDataExtra,
      [name]: value,
    });
  };
  const handleCloseExtra = () => {
    setShowModalRecuring(false);
    setFormDataExtra(null);
  };
  const openModalExtra = () => {
    setShowModalRecuring(true);
  };
  const handleSubmitExtra = async () => {
    setShowModalRecuring(false);
    try {
      setLoading(true);
      const res = await MODULE_API.createPayOffData({
        snowball: +formDataExtra.Extra,
        strategy: selectedPriority,
      });
      setLoading(false);
      getDebtPayOff();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormDataExtra(null);
  };

  const handleClose = () => {
    setShowModal(false);
    setFormData(null);
  };
  const openModal = () => {
    setShowModal(true);
  };
  const handleSubmit = async () => {
    setShowModal(false);
    try {
      setLoading(true);
      const res = await MODULE_API.createOneTimePayment({
        payment: +formData.payment,
        nickname: formData.nickname,
        date: formData.date && moment(formData.date).format("YYYY-MM-DD"),
      });
      setLoading(false);
      if (res.status && res.status === 200) {
        swal("Success", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
  };

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleDeleteOneTime = async (id) => {
    try {
      setLoading(true);
      const res = await MODULE_API.DeleteOneTimePayment(id);
      setLoading(false);
      if (res.status && res.status === 200) {
        swal("Deleted", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };
  const handleSubmitUpdate = async () => {
    setShowModal(false);
    console.log("handleChangeUpdate submit", formData);
    try {
      setLoading(true);
      const res = await MODULE_API.UpdateOneTimePayment({
        ...formData,
        payment: +formData.payment,
        nickname: formData.nickname,
        date: formData.date && moment(formData.date).format("YYYY-MM-DD"),
      });
      setLoading(false);
      if (res.status && res.status === 200) {
        swal("Success", res.message, "success");
      } else if (res.status && res.status === 400) {
        swal("Error", res.message, "error");
      }
      await getOneTimeFundingPayment();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    setFormData(null);
  };
  const createPayOff = async (strategy) => {
    try {
      setLoading(true);
      const res = await MODULE_API.createPayOffData({
        // "amount": 300,
        snowball: extraAmount,
        strategy: strategy,
      });
      setLoading(false);
      console.log("ressss", res);
      getDebtPayOff();
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
    // setFormData(null);
  };

  const getLiabilitesList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=1&limit=50&clientId=${ID}`
            : `?module=Liabilities and Credit&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        datares.records.map((item) => {
          if (item.subType == "Credit") {
            item["Nickname of Liabilities"] = item["Nickname of Credit"];
            item["Initial Loan Amount"] = item["Credit Balance"];
            item["Interest Rate"] = item["Interest Rate (or APR%)"];
            item["Maturity Date"] = item["Point Expiration"];
            item["Name of Financial Institution"] = item["Name of Issuer"];
            item["Monthly Payment"] =
              item["Monthly Payment"] && item["Monthly Payment"].toString();
            item["Start Date"] = new Date();
            item["subType"] = item.subType;
          }
        });
        setLiabilitesCredit(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getDebtPayOff = async () => {
    try {
      setLoading(true);
      let datares = await MODULE_API.getPayOffData();

      if (datares && datares.data && datares.data.rows) {
        if (datares.data.rows[0]) {
          setSelectedPriority(datares.data.rows[0].strategy);
          setExtraAmount(datares.data.rows[0].snowball);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getOneTimeFundingPayment = async () => {
    try {
      setLoading(true);
      const response = await MODULE_API.getOneTimeFunding();

      if (response && response.data) {
        setOneTimeFundingData(
          response.data.filter((item) => item.paid === true)
        );
        setOneTimeFundingDataUnpaid(
          response.data.filter((item) => item.paid === false)
        );
        setOneTimeFunding(response.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error getting OneTimeFundingFromServer:", error);
    }
  };
  const getAll = async () => {
    setAmortizationLoading(true);
    await getLiabilitesList();
    await getDebtPayOff();
    setAmortizationLoading(false);
  };

  useEffect(() => {
    getOneTimeFundingPayment();
    getAll();
  }, []);

  useEffect(() => {
    if (liabilitiesCredit && liabilitiesCredit.length > 0) {
      // Convert liabilities data to the format expected by calculateDebtPayoff
      const debts = liabilitiesCredit.map((item) => {
        let rawDate = item["Start Date"];
        let startDate = rawDate ? new Date(rawDate) : new Date();
        if (isNaN(startDate.getTime())) {
          startDate = new Date();
        }
        return {
          nickname: item["Nickname of Liabilities"],
          initialBalance: parseFloat(item["Initial Loan Amount"]) || 0,
          interestRate: parseFloat(item["Interest Rate"]) / 100 || 0,
          monthlyPayment: parseFloat(item["Monthly Payment"]) || 0,
          startDate,
        };
      });
      // Calculate without snowball
      const withoutSnowball = calculateDebtPayoff(
        debts,
        0,
        {},
        selectedPriority === "Highest Interest First"
          ? "highestInterest"
          : "lowestBalance"
      );
      // Calculate with snowball
      const withSnowball = calculateDebtPayoff(
        debts,
        extraAmount,
        oneTimeFundingData.reduce(
          (acc, payment) => ({
            ...acc,
            [moment(payment.date).format("MMM-YY")]: payment.payment,
          }),
          {}
        ),
        selectedPriority === "Highest Interest First"
          ? "highestInterest"
          : "lowestBalance"
      );

      const allAmortizationData = generateAmortizationData({
        liabilitiesData: liabilitiesCredit,
        snowball: extraAmount,
        oneTimeFundingDataUnpaid,
        selectedPriority,
      });
      const allAmortizationDataWithNOSnowBall = generateAmortizationData({
        liabilitiesData: liabilitiesCredit,
        selectedPriority: selectedPriority || "",
      });
      setAmortizationDataWithNoSnowball(allAmortizationDataWithNOSnowBall);

      setAmortizationData({
        allAmortizationData,
        withSnowball,
        withoutSnowball,
      });
    }
  }, [
    liabilitiesCredit,
    selectedPriority,
    extraAmount,
    oneTimeFundingData,
    oneTimeFundingDataUnpaid,
    // refreshKey,
  ]);

  const tableData =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.amortizationTable;

  let totalPrincipalCurrentMonth = 0;

  if (tableData && tableData.header && tableData.data) {
    const header = tableData.header;
    const dataRows = tableData.data;

    // find current month in data
    const currentMonthName = moment().format("MMM-YY"); // e.g. "Sep-25"
    const currentRow = dataRows.find((row) => row[0] === currentMonthName);

    if (currentRow) {
      currentRow.forEach((value, index) => {
        const colName = header[index];
        // skip first column (month), unwanted columns, and last column (End Balance)
        if (
          index > 0 &&
          index !== header.length - 1 && // exclude last column
          colName !== "Snowball" &&
          colName !== "One-time Funding" &&
          value !== ""
        ) {
          totalPrincipalCurrentMonth +=
            parseFloat(value.toString().replace(/,/g, "")) || 0;
        }
      });
    }
  }

  const originalDate =
    amortizationData &&
    amortizationData.withoutSnowball &&
    amortizationData.withoutSnowball.originalDebtFreeDate;

  const newDate =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.newDebtFree;

  // Get original and new interest paid
  const originalInterest =
    amortizationData &&
    amortizationData.withoutSnowball &&
    amortizationData.withoutSnowball.totalInterestPaid
      ? amortizationData.withoutSnowball.totalInterestPaid
      : 0;

  const newInterest =
    amortizationData &&
    amortizationData.allAmortizationData &&
    amortizationData.allAmortizationData.newDebtIntrest
      ? amortizationData.allAmortizationData.newDebtIntrest
      : 0;

  let timeSaved = "N/A";

  if (originalDate && newDate) {
    const original = moment(originalDate, ["MM-DD-YYYY", "MMM, YYYY"]);
    const latest = moment(newDate, ["MM-DD-YYYY", "MMM, YYYY"]);

    if (original.isValid() && latest.isValid()) {
      const monthsDiff = original.diff(latest, "months");

      if (monthsDiff > 0) {
        const years = Math.floor(monthsDiff / 12);
        const months = monthsDiff % 12;
        timeSaved =
          years > 0 ? `${years} Years, ${months} Months` : `${months} Months`;
      } else {
        timeSaved = "0 Months";
      }
    }
  }

  // Calculate interest saved
  const interestSaved = originalInterest - newInterest;

  const debtCards = [
    {
      id: 1,
      title: "Original Debt Free",
      value: originalDate
        ? moment(originalDate, "MM-DD-YYYY").format("MMMM, YYYY")
        : "N/A",
    },
    {
      id: 2,
      title: "New Debt Free",
      value: newDate ? newDate : "N/A",
    },
    {
      id: 3,
      title: "Total Interest Paid (Old Plan)",
      value: originalInterest
        ? `$${originalInterest.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "N/A",
    },
    {
      id: 4,
      title: "Total Interest Paid (New Plan)",
      value: newInterest
        ? `$${newInterest.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "N/A",
    },
  ];
  const debtTotalCards = [
    {
      id: 1,
      title: "Time Saved 🎉",
      value: timeSaved,
    },
    {
      id: 2,
      title: "Interest Saved 🎉",
      value: interestSaved
        ? `$${interestSaved.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`
        : "$0.00",
    },
  ];
  const stragtegyButtons = [
    {
      id: 1,
      title: "Highest Interest First",
      selected: selectedPriority === "Highest Interest First",
    },
    {
      id: 2,
      title: "Lowest Balance First",
      selected: selectedPriority === "Lowest Balance First",
    },
  ];

  const monthlyFundings = [
    {
      id: 1,
      title: "Monthly Amount",
      value: totalPrincipalCurrentMonth.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    },
    {
      id: 2,
      title: "Monthly Extra",
      value: extraAmount ? `$${extraAmount.toLocaleString()}` : "$0.00",
    },
  ];
  return (
    <div className="debt-main">
      <div className="debt-create">
        <div className="add-debt-section">
          <div className="addTitle">
            Strategy
            <span style={{ marginLeft: "10px" }}>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/debt-payOff");
                        }}
                      >
                        Debt Payoff
                      </div>
                    </Menu.Item>
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
        </div>
      </div>

      <div className="debt-main-report">
        <div className="debt-card1">
          <h3 className="debt-report-heading-strategy">
            Highest Interest First
          </h3>
          <div className="debt-row" style={{ height: "88%" }}>
            <div className="debt-image-and-amount-container">
              <div className="debt-strategy-container">
                {debtCards &&
                  debtCards.map((item, index) => (
                    <div key={index} className="debt-strategy-section">
                      <div className="debt-heading-container">{item.title}</div>
                      <div className="debt-report-amount-section">
                        {loading || amortizationLoading ? (
                          <NumberCardSkeleton />
                        ) : (
                          item.value
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div
              className="debt-image-and-amount-container"
              style={{ marginBottom: "0px" }}
            >
              <div className="debt-strategy-container">
                {debtTotalCards &&
                  debtTotalCards.map((item, index) => (
                    <div
                      key={index}
                      className="debt-strategy-section"
                      style={{ background: "#E8FFE9" }}
                    >
                      <div className="debt-heading-container">{item.title}</div>
                      <div className="debt-report-amount-section">
                        {loading || amortizationLoading ? (
                          <NumberCardSkeleton />
                        ) : (
                          item.value
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="debt-card-strategy" style={{ position: "relative" }}>
          <StrategyReport
            amortizationData={amortizationData && amortizationData}
            loading={amortizationLoading || loading}
            amortizationDataWithNoSnowball={
              amortizationDataWithNoSnowball && amortizationDataWithNoSnowball
            }
          />
          <div className="debt-card-strategy-card-container">
            <div
              className="debt-card-strategy-card-inner"
              // style={{ height: "50%" }}
            >
              {stragtegyButtons &&
                stragtegyButtons.map((item, index) => (
                  <div key={index} style={{ marginBottom: index === 0 && "1rem" }}>
                    <div className="debt-card-stragtegy-inner-heading">
                      {item.title}
                    </div>

                    {item.selected ? (
                      <div className="selectedbutton">Selected</div>
                    ) : (
                      <div
                        className="selectbutton"
                        onClick={() => {
                          createPayOff(item.title);
                        }}
                      >
                        Select
                      </div>
                    )}
                  </div>
                ))}
            </div>
            <div
              className="debt-card-strategy-card-inner"
              // style={{ height: "50%" }}
            >
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <img
                  src={recurringImg}
                  style={{ height: "32px", width: "32px" }}
                  height={20}
                  width={20}
                  alt="onetime"
                ></img>
                <div className="debt-card-stragtegy-inner-heading">
                  Monthly Funding
                </div>
              </div>
              <div className="debt-monthly-column">
                <div className="debt-monthly-payments">
                  {monthlyFundings &&
                    monthlyFundings.map((item, index) => (
                      <div className="debt-monthly-card" key={index}>
                        <div className="debt-monthly-heading">{item.title}</div>
                        <div className="debt-monthly-value-payment">
                          {item.value}
                          {item.title === "Monthly Extra" && (
                            <div
                              className="AddButton"
                              onClick={() => {
                                openModalExtra();
                              }}
                            >
                              <img src={addIcon} alt="addicon" />
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                </div>
                <div className="debt-monthly-card-total">
                  <div className="debt-monthly-heading">Total</div>
                  <div className="debt-monthly-value">
                    {(() => {
                      const total =
                        (extraAmount
                          ? extraAmount + totalPrincipalCurrentMonth
                          : totalPrincipalCurrentMonth) || 0;
                      return total.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      });
                    })()}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="debt-card-strategy-card-inner"
              style={{ height: "100%" }}
            >
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <img
                  src={oneTimeFundingImg}
                  style={{ height: "32px", width: "32px" }}
                  height={20}
                  width={20}
                  alt="onetime"
                ></img>
                <div className="debt-card-stragtegy-inner-heading">
                  One-time Funding
                </div>
                <div
                  className="AddButton"
                  style={{ minWidth: "20px" }}
                  onClick={() => {
                    openModal();
                  }}
                >
                  <img src={addIcon} alt="addicon"></img>
                </div>
              </div>
              <div>
                {oneTimeFundingDataUnpaid &&
                oneTimeFundingDataUnpaid.length > 0 ? (
                  oneTimeFundingDataUnpaid.map((item, index) => (
                    <div className="debt-amounts-container-main" key={index}>
                      <div className="debt-amounts-container-strategy">
                        <div className="debt-monthly-payout-heading">
                          {item.nickname ? item.nickname : "N/A"}
                        </div>
                        <div className="debt-monthly-date-heading">
                          {item.date && moment(item.date).format("MM-DD-YYYY")}
                        </div>
                        <div className="debt-monthly-value-heading">
                          {item.payment
                            ? item.payment &&
                              `$${parseFloat(item.payment)
                                .toFixed(2)
                                .toLocaleString()}`
                            : "$0.00"}
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div>
                          <Icon
                            type="edit"
                            onClick={() => {
                              setFormData(item);
                              openModal();
                            }}
                            style={{
                              padding: "5px",
                              fontSize: "22px",
                              color: "#2a3da3",
                            }}
                          />
                        </div>
                        <div>
                          <Icon
                            type="delete"
                            onClick={() => {
                              handleDeleteOneTime(item.id);
                            }}
                            style={{
                              padding: "5px",
                              fontSize: "22px",
                              color: "#fa2a2a",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="nodata">No Data to Show</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <StrategyAmortization
        amortizationData={amortizationData && amortizationData}
        monthlyPayment={totalPrincipalCurrentMonth && totalPrincipalCurrentMonth}
        loading={amortizationLoading || loading}
      />
      {showModal && (
        <AddOneTimeFunding
          showModal={showModal}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          handleSubmitUpdate={handleSubmitUpdate}
          onClose={handleClose}
          formData={formData}
        />
      )}
      {showModalRecuring && (
        <AddMonthlyExtra
          handleChange={handleChangeExtra}
          handleSubmit={handleSubmitExtra}
          formData={formDataExtra}
          closeModal={handleCloseExtra}
          showModal={showModalRecuring}
        />
      )}
    </div>
  );
};
